/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const listReviewerPerformanceRecentChallengesV1QuerySchema = z.object({
  userId: z.string().min(1),
  limit: z.coerce.number().int().min(1).max(50).default(10),
});

export type IListReviewerPerformanceRecentChallengesV1Query = z.input<
  typeof listReviewerPerformanceRecentChallengesV1QuerySchema
>;
